var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailIcon = function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "nonzero",
    d: "M.968.408v22.368h32V.408zm28.288 1.76L16.968 13.72 4.68 2.168zm1.984 1.6v17.248H2.696V2.936l14.272 13.216L31.24 2.936z"
  })));
};
export default SvgEmailIcon;